export enum AlertMessageType {
  Error = 'danger',
  Warning = 'warning',
  Success = 'success',
  Info = 'info'
}
